import testResultCode, { testCodes as codeDictionary } from './test';

export default {
    isAvailable: codeDictionary.enabled === testResultCode,
    code: testResultCode,
    get(key) {
        return localStorage.getItem(key);
    },
};
